var _rect, _rect2, _rect3, _rect4, _rect5, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkyFlap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 40,
    fill: "#65c8ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    width: 85,
    height: 175,
    fill: "#725cff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 305,
    width: 85,
    height: 145,
    fill: "#725cff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 605,
    width: 85,
    height: 110,
    fill: "#725cff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 605,
    y: 240,
    width: 85,
    height: 210,
    fill: "#725cff"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 260,
    fontSize: 135
  }, "\uD83D\uDC26")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 405,
    textAnchor: "middle",
    fill: "#17233a",
    fontFamily: "sans-serif",
    fontSize: 62,
    fontWeight: 800
  }, "SKY FLAP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyFlap);
export default __webpack_public_path__ + "static/media/sky_flap.eff4bb650de5bf6ccb8654c060bfda1a.svg";
export { ForwardRef as ReactComponent };